<template>
  <div>
    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업개요</h5>
      <div class="writeGridContainer">
        <div>
          <div>작업공정</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_1" />
        </div>
        <div>
          <div>작업장소</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_2 " />
        </div>
        <div>
          <div>작업업체</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_3 " />
        </div>

        <div>
          <div>작업인원</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_4 " />
        </div>
        <div>
          <div>작업기간</div>
          <div class="time">
            <date-selector v-model="work.inputA_5" :readonly="board.readonly" />
            <p>~</p>
            <date-selector v-model="work.inputA_6" :readonly="board.readonly" />
          </div>
        </div>
        <div class="hidden xl:block"></div>

        <div>
          <div>운반경로(시점)</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_7 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_7 " />
        </div>
        <div>
          <div>운반경로(종점)</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_8 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputA_8 " />
        </div>
        <div>
          <div>운반도면 첨부</div>
          <p v-if="isPrint" class="print-input">{{ work.inputA_9.fileName }}</p>
          <file-uploader v-else :readonly="board.readonly" v-model="work.inputA_9" class="w-full flex-1" />
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 사전조사 내용</h5>
      <div class="writeGridContainer">
        <div>
          <div>건설기계 작동상태</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_1 }}</p>
          <div v-else>
            <vs-radio class="mr-4" v-model="work.inputB_1" :disabled="board.readonly" vs-name="inputB_1" vs-value="적정">적정</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputB_1" :disabled="board.readonly" vs-name="inputB_1" vs-value="보통">보통</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputB_1" :disabled="board.readonly" vs-name="inputB_1" vs-value="부적정">부적정</vs-radio>
          </div>
        </div>
        <div>
          <div>경사지 등 장비정차 위치 상태</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_2 }}</p>
          <div v-else>
            <vs-radio class="mr-4" v-model="work.inputB_2" :disabled="board.readonly" vs-name="inputB_2" vs-value="견고">견고</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputB_2" :disabled="board.readonly" vs-name="inputB_2" vs-value="보통">보통</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputB_2" :disabled="board.readonly" vs-name="inputB_2" vs-value="연약">연약</vs-radio>
          </div>
        </div>
        <div>
          <div>장소 안전거리 확보 상태</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_3 }}</p>
          <div v-else>
            <vs-radio class="mr-4" v-model="work.inputB_3" :disabled="board.readonly" vs-name="inputB_3" vs-value="적정">적정</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputB_3" :disabled="board.readonly" vs-name="inputB_3" vs-value="보통">보통</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputB_3" :disabled="board.readonly" vs-name="inputB_3" vs-value="부적정">부적정</vs-radio>
          </div>
        </div>

        <div>
          <div>안전장치 확인 상태</div>
          <p v-if="isPrint" class="print-input">{{ work.inputB_4 }}</p>
          <div v-else>
            <vs-radio class="mr-4" v-model="work.inputB_4" :disabled="board.readonly" vs-name="inputB_4" vs-value="적정">적정</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputB_4" :disabled="board.readonly" vs-name="inputB_4" vs-value="보통">보통</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputB_4" :disabled="board.readonly" vs-name="inputB_4" vs-value="부적정">부적정</vs-radio>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 기계제원</h5>
      <div class="writeGridContainer">
        <div>
          <div>장비명</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_1" />
        </div>
        <div>
          <div>제작연도</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_2 " />
        </div>
        <div>
          <div>제조사(모델명)</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_3 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_3 " />
        </div>

        <div>
          <div>운전원 성명</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_4 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_4 " />
        </div>
        <div>
          <div>운전원 면허</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_5 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_5 " />
        </div>
        <div class="hidden xl:block"></div>

        <div>
          <div>유도자 성명</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_6 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_6 " />
        </div>
        <div>
          <div>신호방법</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_7 }}</p>
          <div v-else>
            <vs-radio class="mr-4" v-model="work.inputC_7" :disabled="board.readonly" vs-name="inputC_7" vs-value="수신호">수신호</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputC_7" :disabled="board.readonly" vs-name="inputC_7" vs-value="무선">무선</vs-radio>
            <vs-radio class="mr-4" v-model="work.inputC_7" :disabled="board.readonly" vs-name="inputC_7" vs-value="기타">기타</vs-radio>
          </div>
        </div>
        <div class="hidden xl:block"></div>

        <div>
          <div>등록번호</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_8 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_8 " />
        </div>
        <div>
          <div>차체중량</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_9 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_9 " />
        </div>
        <div>
          <div>인양하중<br/>(최대/최소)</div>
          <p v-if="isPrint" class="print-input">{{ work.inputC_10 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputC_10 " />
        </div>
      </div>
    </div>

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 작업방법</h5>
      <div class="writeGridContainer">
        <div class="writeGridLineItem">
          <div>작업방법</div>
          <p v-if="isPrint" class="print-input">{{ work.inputD_1 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputD_1 " />
        </div>
        <div class="writeGridLineItem">
          <div>작업순서</div>
          <p v-if="isPrint" class="print-input">{{ work.inputD_2 }}</p>
          <ml-input v-else :readonly="board.readonly" v-model="work.inputD_2 " />
        </div>
      </div>
    </div>

    <table-custom
      :board="board"
      :is-print="isPrint"
      :controls="true"
      title="기본 안전대책"
      :tableData="[
        { id: 'input1', title: '위험요인', type: 'text', placeholder: '' },
        { id: 'input2', title: '재해 예방 대책', type: 'text', placeholder: '' },
      ]"
      v-model="work.measureList"
    >
      <template #customSubTitle>
        <div class="writeGridContainer mb-3">
          <div>
            <div>제한속도 지정</div>
            <p v-if="isPrint" class="print-input">{{ work.inputE_1 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="work.inputE_1" />
            &nbsp;&nbsp;km/hr
          </div>
          <div>
            <div>운전원 이탈 시 조치</div>
            <p v-if="isPrint" class="print-input">{{ work.inputE_2 }}</p>
            <ml-input v-else :readonly="board.readonly" v-model="work.inputE_2" />
          </div>
        </div>
      </template>
    </table-custom>


    <!-- 근로자 안전보건교육 확인 -->
    <table-custom
      :controls="true"
      :board="board"
      :is-print="isPrint"
      title="근로자 안전보건교육 확인"
      title-type="html"
      :tableData="[
        { id: 'input1', title: '근로자명', type: 'text', placeholder: '' },
        { id: 'input2', title: '교육내용', type: 'text', placeholder: '' },
        { id: 'input3', title: '이수 확인', type: 'text', placeholder: '' },
        { id: 'input4', title: '검토자 확인', type: 'text', placeholder: '' },
      ]"
      :mobile="['input1', 'input2']"
      v-model="work.trainingList"
      class="mt-4"
    />

    <div class="mt-28px">
      <h5 class="mb-4"><i class="dot"></i> 차량계 건설기계 작업계획도 <span style="color: #4839EB; font-size: 15px;">※ 해당 구역 표시 요망</span></h5>
      <div>
        <table>
          <tbody>
          <tr>
            <th>범 례 : 관리감독자, 신호수, 작업원, 장비</th>
          </tr>
          <tr>
            <td>
              <div class="grid grid-cols-12 h-upload">
                <div class="col-span-12 upload-content">
                  <div class="upload-content__file">
                    <FileUploader
                      v-if="!isPrint"
                      type="only-image"
                      v-model="work.inputG_1"
                      class="img-contain"
                    />
                  </div>
                  <div class="pl-4 pr-4">
                    <ml-textarea rows="5" v-model="work.inputG_2" :readonly="board.readonly" />
                  </div>
                </div>
              </div>
            </td>
          </tr>

          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import TimeSelector from "@/components/selector/TimeSelector.vue";
import TableCustom from "@/components/TableCustom.vue";
import FileUploader from "@/components/FileUploader.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  name: "WorkConstructionMachinery",
  components: {DateSelector, FileUploader, TableCustom, TimeSelector},
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    work: Object,
  },
  watch: {
    work: {
      immediate: true,
      deep: true,
      handler(value) {
        if (!this.work.measureList || this.work.measureList.length === 0) {
          this.work.measureList = this.initMeasureList;
        }

        if (!this.work.trainingList || this.work.trainingList.length === 0) {
          this.work.trainingList = this.initTrainingList;
        }


        this.$emit("input", value);
      },
    },
  },
  mounted() {
    if (!this.work.inputG_1) {
      this.work.inputG_1 = {
        "id": 3449,
        "fileName": "884c1b59fd1347a004ffeb9dda79f8ec.png",
        "fileSize": 653352,
        "path": "https://dgjg.maot.co.kr:8080/storage/app/uploads/public/65d/313/345/65d313345318e583342475.png",
        "thumb": "https://dgjg.maot.co.kr:8080/storage/app/uploads/public/65d/313/345/65d313345318e583342475.png" };
    }
  },
  data() {
    return {
      initMeasureList: [
        { id: 1, input1: "", input2: "", },
        { id: 2, input1: "", input2: "", },
        { id: 3, input1: "", input2: "", },
      ],

      initTrainingList: [
        { id: 1, input1: "", input2: "", input3: "", input4: "", },
        { id: 2, input1: "", input2: "", input3: "", input4: "", },
        { id: 3, input1: "", input2: "", input3: "", input4: "", },
      ],
    };
  },
}
</script>

<style lang="scss" scoped>
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    text-align: center;
    min-height: 60px;
    height: 60px;
    font-size: 14px;
  }
  th {
    background-color: #f9f9f9;
    font-weight: 500;
    padding: 0;
    word-break: keep-all;
  }
  td {
    min-width: 50px;
    word-break: keep-all;
    img {
      display: inline-block;
    }
  }
  .th-background {
    background-color: #f9f9f9;
    white-space: nowrap;
  }
  .check-container {
    padding: 10px 14px 0 14px;
    text-align: left;

    div {
      margin-bottom: 8px;
    }
    img {
      display: inline-block;
      margin-right: 8px;
    }
  }
  .text-left {
    text-align: left;
    padding: 10px 14px;
  }
}
.print-break {
  break-inside: avoid;
}
.print-break-page {
  page-break-before: always;
}


/* uploaded File */

.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__file {
    width: 100%;
    padding: 14px;
    height: 416px;
  }
}
.img-contain::v-deep img{
  object-fit: contain;
}
</style>
